<div class="modal-header">
    <h4 class="modal-title">
        {{ 'event-alarms_select-template-header' | translate }}
    </h4>
</div>

<div class="modal-body">
    <div class="row">
        @for (template of templatesSignal(); track template.eventTypeId) {
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="card mb-3" style="min-height: 165px">
                    <div
                        class="card-title d-flex justify-content-between align-items-center me-0 p-3 pb-0">
                        <b class="mb-0">{{ template.typeName }}</b>
                        <app-tooltip [popover]="template.typeDescription" />
                    </div>
                    <div class="card-body py-0">
                        <p class="mb-0">
                            {{
                                template.typeDescription.length > 100
                                    ? (template.typeDescription | slice: 0 : 100) + '…'
                                    : template.typeDescription
                            }}
                        </p>
                    </div>
                    <div class="text-end me-1 mb-1">
                        <button
                            class="btn btn-link"
                            type="button"
                            (click)="selectTemplate(template)">
                            {{ 'common_Select' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        } @empty {
            <div class="text-center w-100 alert alert-warning">
                {{ 'event-alarms_warning_no_usable_meters-or-sensors' | translate }}
            </div>
        }
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-primary" type="button" (click)="close()">
        {{ 'common_cancel_button' | translate }}
    </button>
</div>
